import { render, staticRenderFns } from "./TrTargetGradeGroup.vue?vue&type=template&id=47d7e36a&"
import script from "./TrTargetGradeGroup.vue?vue&type=script&lang=ts&"
export * from "./TrTargetGradeGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports